import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import CacheStorage from "../storage/CacheStorage";
import StorageKeys from "../../const/StorageKeys";

type DeviceInfoType = {
  uiId: string;
  userAgent: string;
  platform: string;
  language: string;
  screenWidth: number;
  screenHeight: number;
};

export const deviceInfo: DeviceInfoType = {
  uiId: uuidv4(),
  userAgent: navigator.userAgent,
  /*  platform:
    navigator.userAgentData?.brands != null
      ? `${navigator.userAgentData?.brands[0]["brand"]}|${
          navigator.userAgentData?.brands[0]["version"]
        }|${navigator.userAgentData?.platform ?? navigator.platform}`
      : "", */
  platform: navigator.platform,
  language: navigator.language,
  screenWidth: window.screen.width,
  screenHeight: window.screen.height,
};

export const getIPLocation = async () => {
  // https://api.ipify.org/?format=json
  const dataResponse: any = await axios.get(`https://ipapi.co/json/`);
  if (parseInt(dataResponse.status) === 200) {
    CacheStorage.saveValue(
      StorageKeys.web_ip_info,
      JSON.stringify(dataResponse.data)
    );
  }
};
